// extracted by mini-css-extract-plugin
module.exports = {"title":"AddressDetailsPage_title__Ho3Lk","outerContainer":"AddressDetailsPage_outerContainer__qgmEQ"};